export const efdocConstants = {
  /*********
   수신함 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_EFDOC_SEARCH_REQUEST',

  /*********
   수신함 목록 조회
   **********/
  EFDOC_REQUEST: 'GET_EFDOC_REQUEST',
  EFDOC_SUCCESS: 'GET_EFDOC_SUCCESS',
  EFDOC_FAILURE: 'GET_EFDOC_FAILURE',
  EFDOC_ORG_REQUEST: 'GET_EFDOC_ORG_REQUEST',
  EFDOC_ORG_SUCCESS: 'GET_EFDOC_ORG_SUCCESS',
  EFDOC_ORG_FAILURE: 'GET_EFDOC_ORG_FAILURE',
 
  /***********
   히스토리 관리
   ************/
   EFDOC_HISTORY: 'SET_EFDOC_HISTORY',

     /***********
   증명서 PDF BASE64STRING 조회
   ************/
  PDF_REQUEST: 'PDT_REQUEST',
  PDF_SUCCESS: 'PDF_SUCCESS',
  PDF_FAILURE: 'PDF_FAILURE',

  /***********
   PDF 호출 init 처리
   ************/
  INIT_FLAG_REQUEST: 'INIT_FLAG_REQUEST',
  
  /***********
   상태관련 state 초기화
   ************/
   CLEAR_REQUEST: 'CLEAR_REQUEST',

   /***********
    증명서 첨부파일 다운로드
    ************/
   FILE_REQUEST: 'FILE_REQUEST',
   FILE_SUCCESS: 'FILE_SUCCESS',
   FILE_FAILURE: 'FILE_FAILURE',

}